// extracted by mini-css-extract-plugin
module.exports = {"App":"styles_App__1BRZA"};